import { useEffect, useRef, Ref } from 'react'

export const useDynamicTimeout = (callback: () => void, delay?: number | null): Ref<NodeJS.Timeout | null> => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const savedCallback = useRef(callback)

  useEffect((): void => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = (): void => savedCallback.current()
    if (typeof delay === 'number') {
      timeoutRef.current = setTimeout(tick, delay)
      return () => {
        if (timeoutRef.current !== null) {
          clearTimeout(timeoutRef.current)
        }
      }
    }
  }, [delay])

  return timeoutRef
}
